import * as React from 'react';
import { Link } from 'gatsby';

import styled from 'styled-components';

type Props = {
  totalCount?: number;
  current?: string;
  tag?: string;
};

type ArrowProps = {
  prev?: boolean;
};

const Arrow = styled.div<ArrowProps>`
  display: block;
  width: 10px;
  height: 10px;
  transform: ${({ prev }) =>
    prev
      ? `rotate(-45deg) translateY(2px) translateX(2px)`
      : `rotate(135deg) translateY(2px) translateX(2px)`};

  &:before {
    position: absolute;
    content: '';
    display: block;
    width: 2px;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColors.black};
  }

  &:after {
    position: absolute;
    content: '';
    display: block;
    width: 100%;
    height: 2px;
    background-color: ${({ theme }) => theme.backgroundColors.black};
  }
`;

const Count = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  min-width: 42px;
  padding: ${({ theme }) => theme.spaces.m};
  border: 1px solid ${({ theme }) => theme.borderColors.default};
  border-radius: ${({ theme }) => theme.radii.m};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  transition-duration: ${({ theme }) => theme.transitions.fast};

  &.active,
  &:hover {
    background-color: ${({ theme }) => theme.backgroundColors.primary};
    color: ${({ theme }) => theme.fontColors.white};
    border-color: ${({ theme }) => theme.borderColors.primary};

    ${Arrow} {
      &:before,
      &:after {
        background-color: ${({ theme }) => theme.backgroundColors.white};
      }
    }
  }
`;

const PagerList = styled.li`
  margin: 0;
  padding: 0;
`;

const Root = styled.ul`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spaces.m};
  margin: ${({ theme }) => `0 0 ${theme.spaces.xxxl}`};
  padding: 0;
  list-style: none;
`;

export const Pagination = (props: Props) => {
  const perPage = 12;
  const pagesToShow = 5;

  const range = (start: number, end: number) =>
    [...Array(end - start + 1)].map((_, i) => start + i);

  // 現在のページ番号を取得

  const currentPageNum = props.current.replace(/[^0-9]/g, '');
  const currentPage = parseInt(currentPageNum || '1'); // 現在のページ番号。デフォルトは1

  // 現在のページ番号を中心に、前後のページ番号を取得
  const startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
  const endPage = Math.min(
    startPage + pagesToShow - 1,
    Math.ceil(props.totalCount / perPage),
  );

  return (
    <Root>
      {currentPage == 2 ? (
        <Count to={`/blog${props.tag && props.tag}`} activeClassName="active">
          <Arrow prev />
        </Count>
      ) : (
        currentPage !== startPage && (
          <Count
            to={`/blog${props.tag && props.tag}${currentPage - 1}`}
            activeClassName="active"
          >
            <Arrow prev />
          </Count>
        )
      )}
      {range(startPage, endPage).map((number, index) => (
        <PagerList key={index}>
          <Count
            to={`/blog${props.tag && props.tag}${
              number === 1 ? '' : `${number}`
            }`}
            activeClassName="active"
          >
            {number}
          </Count>
        </PagerList>
      ))}
      {currentPage !== endPage && (
        <Count
          to={`/blog${props.tag && props.tag}${currentPage + 1}`}
          activeClassName="active"
        >
          <Arrow />
        </Count>
      )}
    </Root>
  );
};
